import { LoaderMega } from '@/shared/ui/Loader/LoaderMega'

export type PropsCargando = {
  /** Mensaje opcional (se formatea a 3 palabras mayúsculas con '...'). */
  mensaje?: string
  /** Ocupa toda la pantalla con centrado fijo en viewport. */
  pantallaCompleta?: boolean
  /** Para bloques internos compactos (tarjetas, modales). */
  compacto?: boolean
  /** Ruta opcional para derivar el mensaje canónico. */
  ruta?: string
  className?: string
}

/**
 * Estado de carga institucional de MEGA Distribuciones y Proyectos S.A.S.
 *
 * Utiliza el isotipo animado con resplandor exterior blanco puro (16px), calibrado a 2.2s,
 * avance en Z de 45px y escala 1.13, con centrado absoluto horizontal y vertical.
 */
export function Cargando({
  mensaje,
  pantallaCompleta = false,
  compacto = false,
  ruta,
  className,
}: PropsCargando) {
  return (
    <LoaderMega
      mensaje={mensaje}
      pantallaCompleta={pantallaCompleta}
      compacto={compacto}
      ruta={ruta}
      className={className}
    />
  )
}
